module.exports = __webpack_public_path__ + "static/media/xiaomi-notifications.5fc10a8a.mp3";